<template>
  <a-card>
    <div class="nav">
      <a-row :gutter="16" type="flex">
        <a-col v-for="item in navOptions" :key="item.key" class="a-col">
          <span class="mr-2">{{ item.title }}</span>
          <a-select
            v-model:value="item.value"
            placeholder="请选择"
            :options="item.options"
            style="width: 100%"
            @change="handleChange"
          />
        </a-col>
      </a-row>
      <a-button type="primary" @click="goAdd">新建活动</a-button>
    </div>
  </a-card>

  <div class="container">
    <SearchForm />
    <TableData />
  </div>
</template>

<script>
import { onMounted, provide, reactive, toRefs } from 'vue'
import SearchForm from './components/SearchForm.vue'
import TableData from './components/TableData.vue'
import {
  lottery_activity_pageList,
  lottery_activity_delete,
  lottery_activity_generate_url,
  lottery_activity_personal_center,
  lottery_activity_copy
} from '@/server/modules/8199.js'
import { common_querySiteInfo_get } from '@/server/modules/3426.js'
import { useRoute, useRouter } from 'vue-router'
import { message } from 'ant-design-vue'

export default {
  name: 'ActiveList',
  components: { SearchForm, TableData },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const state = reactive({
      navOptions: [
        {
          title: '品牌',
          key: '1',
          options: [],
          value: route.query?.brandId - 0 || 1
        },
        {
          title: '渠道',
          key: '2',
          options: [],
          value: route.query?.channelId - 0 || 1
        },
        {
          title: '站点',
          key: '3',
          options: [],
          value: route.query?.siteId - 0 || 1
        }
      ],
      dataSource: [],
      value1: 1,
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        onChange: (current, pageSize) => {
          state.pagination.current = current
          state.pagination.pageSize = pageSize
          state.getTableList()
        },
        onShowSizeChange: (current, pageSize) => {
          state.pagination.current = current
          state.pagination.pageSize = pageSize
          state.getTableList()
        }
      },
      formState: {},
      onChangeRangTime(date, dateString) {
        state.formState.startTime = dateString[0]
        state.formState.endTime = dateString[1]
      },
      handleReset() {
        state.formState = {}
        state.getTableList()
      },
      handleChange() {
        state.getTableList()
      },
      async queryData() {
        try {
          const { success, data } = await common_querySiteInfo_get()
          if (success) {
            state.navOptions[0].options = data[1].map(e => ({
              label: e.name,
              value: e.id
            }))
            state.navOptions[1].options = data[2].map(e => ({
              label: e.name,
              value: e.id
            }))
            state.navOptions[2].options = data[3].map(e => ({
              label: e.name,
              value: e.id
            }))
          }
        } catch (error) {
          console.log('error', error)
        }
      },
      handleDelete: async records => {
        try {
          let res = await lottery_activity_delete({
            activityId: records.id
          })
          if (res.success) {
            state.getTableList()
          }
        } catch (error) {
          console.log('error', error)
        }
      },
      handlePreview(record, isEdit = 'edit') {
        const brandId = state.navOptions[0].value
        const channelId = state.navOptions[1].value
        const siteId = state.navOptions[2].value
        router.push({
          name: 'AddActive',
          query: {
            brandId,
            channelId,
            siteId,
            activityId: record.id,
            status: record.status,
            isEdit
          }
        })
      },
      handleQuery() {
        state.pagination.current = 1
        state.getTableList()
      },
      async getTableList() {
        try {
          const { current, pageSize: size } = state.pagination
          const brandId = state.navOptions[0].value
          const channelId = state.navOptions[1].value
          const siteId = state.navOptions[2].value
          const params = {
            current,
            size,

            item: {
              brandId,
              channelId,
              siteId,
              ...state.formState
            }
          }
          let { success, data } = await lottery_activity_pageList(params)
          if (success) {
            state.dataSource = data?.records
            // state.dataSource = [
            //   { activityId: 1, status: 1 },
            //   { activityId: 2, status: 2 },
            //   { activityId: 3, status: 3 }
            // ]
            state.pagination.total = data?.total
          }
        } catch (error) {
          console.log('error', error)
        }
      },
      handleOpenEntry: async (targetVal, record) => {
        // const targetVal = e.target.value
        const params = {
          activityId: record.id,
          personalCenter: targetVal
        }
        let { success, retInfo } = await lottery_activity_personal_center(
          params
        )
        if (success) {
          record.personalCenter = targetVal
        } else {
          message.error(retInfo)
        }
      },
      goAdd() {
        const brandId = state.navOptions[0].value
        const channelId = state.navOptions[1].value
        const siteId = state.navOptions[2].value
        const params = {
          brandId,
          channelId,
          siteId
        }

        router.push({
          name: 'AddActive',
          query: {
            ...params
          }
        })
      },
      copyFun(text) {
        const cInput = document.createElement('input')
        cInput.value = text
        document.body.appendChild(cInput)
        cInput.select() // 选取文本域内容;
        document.execCommand('Copy')
        message.success('复制成功!')
        cInput.remove()
      },
      async generateLink(record, terminalId = 1) {
        // 1是web，2是app
        const params = {
          activityId: record.id,
          terminalId
        }
        let res = await lottery_activity_generate_url(params)
        if (res.success) {
          state.copyFun(res.data)
        }
      },
      async handleCopy(record) {
        let { success, retInfo } = await lottery_activity_copy({
          activityId: record.id
        })
        if (success) {
          message.success('复制成功!')
          state.handleQuery()
        } else {
          message.error(retInfo)
        }
      }
    })
    provide('initData', state)
    onMounted(() => {
      state.queryData()
      state.getTableList()
    })

    return {
      ...toRefs(state)
    }
  }
}
</script>
<style scoped lang="scss">
.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .mr-2 {
    margin-right: 8px;
  }
  .ant-col {
    margin-right: 8px;
    border: 1px solid #d9d9d9;
  }
}
.a-col {
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    flex-shrink: 0;
    position: relative;
    &::after {
      content: ':';
      padding-left: 4px;
    }
  }
}
::v-deep(.nav
    .ant-select:not(.ant-select-customize-input)
    .ant-select-selector) {
  border-color: transparent;
}

.container {
  background-color: #fff;
  margin: 24px;
  padding: 24px;
}
</style>
